import React from "react";
import { STATS } from "../../lib/constants";

export default function Stats() {
    return (
        <section
            id="about"
            className="bg-[#0C4A6E] text-white relative overflow-hidden"
            data-testid="stats-section"
        >
            {/* Background image with dark overlay */}
            <div className="absolute inset-0 opacity-15 mix-blend-luminosity">
                <img
                    src="https://images.pexels.com/photos/3845810/pexels-photo-3845810.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1600"
                    alt=""
                    className="w-full h-full object-cover"
                    loading="lazy"
                />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-[#0C4A6E] via-[#0C4A6E]/95 to-[#0C4A6E]/80" />

            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid md:grid-cols-12 gap-12 relative">
                <div className="md:col-span-5">
                    <div
                        className="overline mb-5"
                        style={{ color: "#BAE6FD" }}
                    >
                        02 / About Momia
                    </div>
                    <h2 className="font-cabinet font-bold text-4xl md:text-5xl leading-tight tracking-tight">
                        A trusted bridge between Indian healthcare
                        manufacturing and the world.
                    </h2>
                </div>
                <div className="md:col-span-7">
                    <p className="text-lg text-sky-50/90 leading-relaxed">
                        We combine decades of pharmaceutical export experience
                        with an integrated view of modern hospital ecosystems.
                        Our partners include WHO-GMP and EU-GMP certified
                        manufacturers for pharma and AYUSH products, alongside
                        engineering teams for hospital planning, medical gas,
                        imaging, labs, CSSD and HIS implementation.
                    </p>

                    <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 border-t border-sky-800/60 pt-10">
                        {STATS.map((s) => (
                            <div
                                key={s.label}
                                data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                            >
                                <div className="font-cabinet font-black text-4xl md:text-5xl tracking-tight">
                                    {s.value}
                                </div>
                                <div className="mt-2 font-mono text-[11px] uppercase tracking-[0.2em] text-sky-200/80">
                                    {s.label}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
